// extracted by mini-css-extract-plugin
export var container = "_nl-0";
export var dotAnimation = "_nl-2";
export var dotsLoading = "_nl-1";